import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import cn from 'classnames';

import ManageBlocks from './ManageBlocks';
import LinkBack from '../widgets/LinkBack';
import BlockInfo from '../widgets/Typography/BlockInfo';
import BlockFiles from '../widgets/Typography/BlockFiles';
import BlockPrograms from '../widgets/Typography/BlockPrograms';
import Typography from '../widgets/Typography/Typography';

import './manage.scss';

class ManageTemplate extends PureComponent {
  render() {
    const {
      meta,
      content,
      programs,
      blocks,
      panel,
      files
    } = this.props.content;

    return (
      <div className={cn('manage', this.props.name)}>
        {(meta) &&
          <Helmet>
            <title>{meta.title}</title>
          </Helmet>
        }

        <div className="container">
          <div className="manage-content">
            <LinkBack link="/manage/subnavigation/">
              управляем <i>вернуться</i>
            </LinkBack>

            <Typography content={content}/>

            <BlockPrograms content={programs} />
          </div>

          <div className="manage-panel">
            <ManageBlocks blocks={blocks} />

            {(!!panel) &&
              <BlockInfo content={panel} />
            }

            {(!!files) &&
              <BlockFiles content={files} />
            }
          </div>
        </div>
      </div>
    );
  }
}

ManageTemplate.propTypes = {
  name: PropTypes.string,
  content: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string
    }),
    content: PropTypes.arrayOf(PropTypes.object),
    programs: PropTypes.arrayOf(PropTypes.object),
    blocks: PropTypes.arrayOf(PropTypes.object),
    panel: PropTypes.shape({
      title: PropTypes.string,
      text: PropTypes.string
    }),
    files: PropTypes.shape({
      title: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.object)
    })
  })
};

export default ManageTemplate;



// WEBPACK FOOTER //
// ./src/components/Manage/ManageTemplate.js